$body.on("click","[data-scroll-target]",function(e){
    e.preventDefault();
    e.stopPropagation();
    let uid=$(this).attr("data-scroll-target");
    let $target=$('[data-is-scroll-target="'+uid+'"]');
    let y=$target.offset().top - 80;
    y-=50;
    TweenLite.to(window, 0.5, {scrollTo:{y:y, x:0}});
    console.log(y);
    NavMenu.close();
    history.pushState({}, {}, $(this).attr("href"));

    return false;
});


// WEBPACK FOOTER //
// ./project/_src/components/data-scroll-target.js